import { Component, JSX, Show } from 'solid-js';
import { Navigate } from '@solidjs/router';
import { authStore } from '../../stores/authStore';

interface ProtectedRouteProps {
  children: JSX.Element;
  fallback?: string;
}

/**
 * ProtectedRoute component
 * Wraps routes that require authentication
 * Redirects to login page if user is not authenticated
 */
const ProtectedRoute: Component<ProtectedRouteProps> = (props) => {
  const isAuth = () => authStore.isAuthenticated();
  const fallbackPath = () => props.fallback || '/login';

  return (
    <Show when={isAuth()} fallback={<Navigate href={fallbackPath()} />}>
      {props.children}
    </Show>
  );
};

export default ProtectedRoute;
